import React from 'react';
import { Outlet } from 'react-router-dom';
import AccountIcon from '../../components/accountIcon';
import styles from './layout.module.scss';
import Logo from '../../../assets/images/logo.svg';
import LanguagePicker from '../../components/LanguagePicker';
import { useTranslation } from 'react-i18next';

const LANGUAGE = process.env.REACT_APP_LANGUAGE || 'en';

const Layout = () => {
  if (!localStorage.getItem('i18nextLng')) {
    localStorage.setItem('i18nextLng', LANGUAGE.toLowerCase());
  }
  const { t } = useTranslation();
  const region = process.env.REACT_APP_REGION;
  return (
    <div>
      <nav role='navigation' className={styles.Header + ' row'}>
        <div className={`col-12 ${region !== 'us' ? 'col-md-10' : ''}`}>
          <a href={process.env.REACT_APP_WEBSITE_HOME}>
            <img src={Logo} alt='HappiestBaby Logo' className='img-fluid' />
          </a>
          <div className={styles.AccountIconContainer}>
            <a
              href={process.env.REACT_APP_LOGIN_URL}
              className='mr-2 d-flex justify-content-center align-items-center'
            >
              <AccountIcon className={styles.AccountIcon} />

              {t('rental_login', 'Rental Login')}
            </a>
          </div>
        </div>
        {region !== 'us' && (
          <div className='col-12 col-md-2  justify-content-center'>
            <LanguagePicker />
          </div>
        )}
      </nav>

      <main className='mt-60'>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
